module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    attrs: {
      "role": "modal"
    }
  }, [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "explicacaoModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "explicacaoModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('botao', {
    attrs: {
      "estilo": "cheio-verde",
      "rotulo": "Entendi",
      "icone": "ok-modal",
      "dismiss": "modal"
    }
  })], 1)])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "role": "side-modal"
    }
  }, [_c('side-modal', {
    attrs: {
      "sides": _vm.navs
    },
    on: {
      "cancela": function($event) {
        return _vm.cancela()
      }
    }
  }, [_c('template', {
    slot: _vm.navs[0].identidade
  }, [_c('div', {
    staticClass: "side-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('article', [_c('div', {
    staticClass: "row row-field"
  }, [_c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', {
    attrs: {
      "for": "nome"
    }
  }, [_vm._v("Nome")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.dependenteModal.nome))])])]), _vm._v(" "), _c('div', {
    staticClass: "row row-field"
  }, [_c('div', {
    staticClass: "form-group col-sm-6"
  }, [_c('label', {
    attrs: {
      "for": "dataNascimento"
    }
  }, [_vm._v("Data de Nascimento")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.dependenteModal.dataNascimento))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-6"
  }, [_c('label', {
    attrs: {
      "for": "sexo"
    }
  }, [_vm._v("Sexo")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.dependenteSexo))])])]), _vm._v(" "), _c('div', {
    staticClass: "row row-field"
  }, [_c('div', {
    staticClass: "form-group col-sm-6"
  }, [_c('label', {
    attrs: {
      "for": "tipo"
    }
  }, [_vm._v("Parentesco")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.dependenteModal.tipo.descricao))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-6"
  }, [_c('label', {
    attrs: {
      "for": "dependeteIr"
    }
  }, [_vm._v("Dependente IR")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.dependenteIr))])])])]), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "row row-field"
  }, [_c('field-validation', {
    attrs: {
      "css-class": "col-md-12 col-sm-12",
      "label": "Nome",
      "field": "nome",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dependenteModal.nome),
      expression: "dependenteModal.nome"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:45'),
      expression: "'required|max:45'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "nome",
      "id": "nome",
      "data-vv-as": "Nome",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    domProps: {
      "value": (_vm.dependenteModal.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dependenteModal, "nome", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "row row-field"
  }, [(_vm.telaEhMobile) ? _c('field-validation', {
    attrs: {
      "css-class": "col-sm-6",
      "label": "Data de Nascimento",
      "field": "dataNascimento",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dependenteModal.dataNascimento),
      expression: "dependenteModal.dataNascimento"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "name": "dataNascimento",
      "id": "dataNascimento",
      "data-vv-as": "Data de Nascimento",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    domProps: {
      "value": (_vm.dependenteModal.dataNascimento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dependenteModal, "dataNascimento", $event.target.value)
      }
    }
  })]) : _c('field-validation', {
    attrs: {
      "css-class": "col-sm-6",
      "label": "Data de Nascimento",
      "field": "dataNascimento",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "dataNascimento",
      "id": "dataNascimento",
      "config": _vm.config,
      "data-vv-as": "Data de Nascimento",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    model: {
      value: (_vm.dependenteModal.dataNascimento),
      callback: function($$v) {
        _vm.$set(_vm.dependenteModal, "dataNascimento", $$v)
      },
      expression: "dependenteModal.dataNascimento"
    }
  })], 1), _vm._v(" "), _c('field-validation', {
    attrs: {
      "css-class": "col-md-6 col-sm-6",
      "label": "Sexo",
      "field": "sexo",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dependenteModal.sexo),
      expression: "dependenteModal.sexo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "sexo",
      "id": "sexo",
      "data-vv-as": "Sexo",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dependenteModal, "sexo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    },
    domProps: {
      "selected": true
    }
  }, [_vm._v("Escolha")]), _vm._v(" "), _vm._l((_vm.sexos), function(sexo) {
    return _c('option', {
      key: sexo.name,
      domProps: {
        "value": sexo.name
      }
    }, [_vm._v("\n                      " + _vm._s(sexo.displayName.toUpperCase()) + "\n                    ")])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "row row-field"
  }, [_c('field-validation', {
    attrs: {
      "css-class": "col-md-6 col-sm-6",
      "label": "Parentesco",
      "field": "parentesco",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dependenteModal.tipo),
      expression: "dependenteModal.tipo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "parentesco",
      "data-vv-as": "Parentesco",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dependenteModal, "tipo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    },
    domProps: {
      "selected": true
    }
  }, [_vm._v("Escolha")]), _vm._v(" "), _vm._l((_vm.graus), function(grau) {
    return _c('option', {
      key: grau.id,
      domProps: {
        "value": grau
      }
    }, [_vm._v("\n                      " + _vm._s(grau.descricao) + "\n                    ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6 col-sm-6"
  }, [_c('label', {
    attrs: {
      "for": "dependeteIr"
    }
  }, [_vm._v("Dependente IR")]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dependenteModal.dependenteIR),
      expression: "dependenteModal.dependenteIR"
    }],
    staticClass: "toggle-switch",
    attrs: {
      "type": "checkbox",
      "id": "dependenteIr",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    domProps: {
      "checked": Array.isArray(_vm.dependenteModal.dependenteIR) ? _vm._i(_vm.dependenteModal.dependenteIR, null) > -1 : (_vm.dependenteModal.dependenteIR)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.dependenteModal.dependenteIR,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dependenteModal, "dependenteIR", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dependenteModal, "dependenteIR", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dependenteModal, "dependenteIR", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "slider"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.dependenteModal.dependenteIR ? 'Sim' : 'Não'))])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "row row-field"
  }, [_c('field-validation', {
    attrs: {
      "css-class": "col-md-6 col-sm-6",
      "label": "CPF",
      "field": "cpf",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dependenteModal.cpfDependente),
      expression: "dependenteModal.cpfDependente"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        cpf_valido: true
      }),
      expression: "{ required: true, cpf_valido: true }"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('###.###.###-##'),
      expression: "'###.###.###-##'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "cpf",
      "id": "cpf",
      "data-vv-as": "CPF",
      "placeholder": "Digite o CPF",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    domProps: {
      "value": (_vm.dependenteModal.cpfDependente)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dependenteModal, "cpfDependente", $event.target.value)
      }
    }
  })])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "side-footer"
  }, [_c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-cinza",
      "rotulo": "Cancelar",
      "icone": "cancela-modal"
    },
    on: {
      "clicado": function($event) {
        return _vm.cancela()
      }
    }
  }), _vm._v(" "), _c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-verde",
      "rotulo": "Salvar",
      "icone": "ok-modal",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    on: {
      "clicado": function($event) {
        return _vm.valida(_vm.dependenteModal)
      }
    }
  })], 1)])], 2)], 1), _vm._v(" "), _c('section', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "main-container container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h4', [_vm._v("\n                Filiação\n                "), (_vm.cadastrado.mostraMultiplosRegistros) ? _c('span', [_vm._v("- " + _vm._s(_vm._f("formataRegistro")(_vm.cadastrado.registro)))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('form', {
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.avanca(_vm.cadastrado, 'Envio')
      }
    }
  }, [_c('div', {
    staticClass: "row row-field"
  }, [_c('field-validation', {
    attrs: {
      "css-class": "col-sm-6",
      "label": "Nome da Mãe",
      "field": "nomeMae",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cadastrado.pessoa.filiacao.mae),
      expression: "cadastrado.pessoa.filiacao.mae"
    }, {
      name: "sem-acentos",
      rawName: "v-sem-acentos"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:45'),
      expression: "'max:45'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "nomeMae",
      "id": "nomeMae",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO',
      "data-vv-as": "Nome da Mãe"
    },
    domProps: {
      "value": (_vm.cadastrado.pessoa.filiacao.mae)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cadastrado.pessoa.filiacao, "mae", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('field-validation', {
    attrs: {
      "css-class": "col-sm-6",
      "label": "Nome do Pai",
      "field": "nomePai",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cadastrado.pessoa.filiacao.pai),
      expression: "cadastrado.pessoa.filiacao.pai"
    }, {
      name: "sem-acentos",
      rawName: "v-sem-acentos"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:45'),
      expression: "'max:45'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "nomePai",
      "id": "nomePai",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO',
      "data-vv-as": "Nome do Pai"
    },
    domProps: {
      "value": (_vm.cadastrado.pessoa.filiacao.pai)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cadastrado.pessoa.filiacao, "pai", $event.target.value)
      }
    }
  })])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h4', [_vm._v("\n                Quadro Familiar \n                "), _c('small', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.abreExplicacaoModal()
      }
    }
  }, [_vm._v("(Regra de edição de dependentes)")])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', [(_vm.cadastrado.pessoa.dependentes.length == 0) ? _c('div', {
    staticClass: "alert alert-warning",
    staticStyle: {
      "text-align": "center",
      "cursor": "pointer"
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "fa fa-flag-o fa-lg"
  }), _vm._v("  Para incluir um\n                  dependente clique em NOVO.\n                ")]) : _c('table', {
    staticClass: "table table-striped table-hover"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.cadastrado.pessoa.dependentes), function(dependente) {
    return _c('tr', {
      key: dependente.id
    }, [_c('td', [_vm._v(_vm._s(_vm._f("tudoMaiusculo")(dependente.nome)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatarCPF")(dependente.cpfDependente)))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs hidden-sm"
    }, [_vm._v("\n                        " + _vm._s(_vm._f("formataData")(dependente.dataNascimento)) + "\n                      ")]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v("\n                        " + _vm._s(_vm._f("tudoMaiusculo")(dependente.tipo.descricao)) + "\n                      ")]), _vm._v(" "), _c('td', [_c('botao', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.left",
        value: ('Visualizar'),
        expression: "'Visualizar'",
        modifiers: {
          "left": true
        }
      }],
      attrs: {
        "tipo": "button",
        "estilo": "vazado-cinza-sm",
        "icone": "visualizar"
      },
      on: {
        "clicado": function($event) {
          return _vm.edita(dependente)
        }
      }
    }), _vm._v(" "), _c('botao', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.right",
        value: ('Editar'),
        expression: "'Editar'",
        modifiers: {
          "right": true
        }
      }],
      attrs: {
        "tipo": "button",
        "estilo": "vazado-cinza-sm",
        "icone": "editar-tabela",
        "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
      },
      on: {
        "clicado": function($event) {
          return _vm.edita(dependente)
        }
      }
    }), _vm._v(" "), _c('botao', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.left",
        value: ('Apagar'),
        expression: "'Apagar'",
        modifiers: {
          "left": true
        }
      }],
      attrs: {
        "tipo": "button",
        "estilo": "vazado-vermelho-sm",
        "icone": "exclui-tabela",
        "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
      },
      on: {
        "clicado": function($event) {
          return _vm.exclui(dependente)
        }
      }
    })], 1)])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 footer-controller-inner"
  }, [_c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "vazado-verde-dir",
      "rotulo": "Novo",
      "icone": "novo-modal",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    on: {
      "clicado": function($event) {
        return _vm.novo()
      }
    }
  })], 1)])])])])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "role": "controller"
    }
  }, [_c('div', {
    staticClass: "container footer-controller"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "vazado-verde-esq",
      "rotulo": "Voltar",
      "icone": "voltar"
    },
    on: {
      "clicado": function($event) {
        return _vm.volta()
      }
    }
  }), _vm._v(" "), _c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-verde-dir",
      "rotulo": "Avançar",
      "icone": "avancar",
      "icone-direita": true,
      "id": "vai"
    },
    on: {
      "clicado": function($event) {
        return _vm.avanca(_vm.cadastrado, 'Envio')
      }
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "explicacaoModalLabel"
    }
  }, [_vm._v("\n              Regra de Edição de Dependentes\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row row-field",
    staticStyle: {
      "padding-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12"
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\n                  Para alterações referentes à dependentes do Imposto de Renda, é obrigatório anexar os formulários\n                  correspondentes.\n                  Os mesmos estão disponíveis na Central do Servidor, na aba "), _c('strong', [_vm._v("FORMULÁRIOS")]), _vm._v(".\n                ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-warning",
    staticStyle: {
      "margin-bottom": "15px",
      "text-align": "justify"
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle fa-lg"
  }), _vm._v("  "), _c('strong', [_vm._v("Atenção:")]), _vm._v(" Para alterações referentes à dependentes do Imposto de Renda, é obrigatório anexar os formulários correspondentes. Os mesmos estão disponíveis na Central do Servidor, na aba "), _c('strong', [_vm._v("FORMULÁRIOS")]), _vm._v(".\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("CPF")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs hidden-sm"
  }, [_vm._v("Data de Nascimento")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Grau de Parentesco")]), _vm._v(" "), _c('th', [_vm._v(" ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ef596ad","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/recadastramento/filiacao/index.vue
// module id = YUax
// module chunks = 5